// Import hooks
import usePageTitle from "global/hooks/usePageTitle";

// Import components
import { Grid, GridItem } from "global/components/Grid";
import ImageManager from "./components/ImageManager";



// ImagesPage.js
const Images = () => {

    
    // Set title inside the page
    usePageTitle("Images"); 



    return (

        <>

            <Grid>

                <GridItem>

                    <div>

                        <ImageManager />

                    </div>

                </GridItem>

            </Grid>

        </>

    )
};

export default Images;